import { FC } from 'react'
import { useParams } from 'react-router-dom'
import {
	Tabs,
	Divider,
	Typography,
	List,
	Card,
	Descriptions
} from 'antd'
import { relayStore } from '../../store/relay'
import { RNRelay, RNRelayType } from '../../helpers/routeNames'
import { PageBreadcrumb } from '../../components/PageBreadcrumb'

const { Title } = Typography

export const RelayOneCharacters: FC = () => {
	const { relayId, relayTypeId } = useParams<{
		relayId: string
		relayTypeId: string
	}>()
	const { relayTypes } = relayStore()

	const relay = relayTypes
		.find((rt) => rt.id === relayTypeId)
		?.relays.find((r) => r.id === relayId)
	const relayType = relayTypes.find(
		(rt) => rt.id === relay?.relayTypeId
	)

	if (!relay || !relayType) {
		return <div>Реле или тип реле не найден</div>
	}

	const mechanicCharacteristics = relayType.mechanics
	const electricCharacteristics = relayType.electrics

	return (
		<div>
			<PageBreadcrumb
				items={[
					{ label: 'Типы реле', path: RNRelayType },
					{ label: relayType.name, path: RNRelayType + '/' + relayTypeId },
					{ label: relay.name, path: RNRelay + '/' + relayId },
					{ label: 'Характеристики' }
				]}
			/>
			<Title level={2}>{relayType.name}</Title>
			<Title level={3}>{relay.name}</Title>
			<Divider />
			<Tabs
				defaultActiveKey="1"
				items={[
					{
						label: 'Механические характеристики',
						key: '1',
						children: (
							<Card title="Характеристики">
								<List
									grid={{ gutter: 16, column: 1 }}
									dataSource={
										mechanicCharacteristics
									}
									renderItem={(item) => (
										<List.Item>
											<Card title={item.name}>
												<Descriptions
													size="small"
													column={1}
													items={[
														{
															label: 'Уровень',
															children:
																item.level
														},
														{
															label: 'Порядок',
															children:
																item.order
														},
														{
															label: 'Измерение',
															children:
																item.measurement
														}
													]}
												/>
											</Card>
										</List.Item>
									)}
								/>
							</Card>
						)
					},
					{
						label: 'Электрические характеристики',
						key: '2',
						children: (
							<Card title="Электрические характеристики">
								<List
									grid={{ gutter: 16, column: 1 }}
									dataSource={
										electricCharacteristics
									}
									renderItem={(item) => (
										<List.Item>
											<Card title={item.name}>
												<Descriptions
													size="small"
													column={1}
													items={[
														{
															label: 'Измерение',
															children:
																item.measurement
														}
													]}
												/>
											</Card>
										</List.Item>
									)}
								/>
							</Card>
						)
					}
				]}></Tabs>
		</div>
	)
}
